export default "__VITE_ASSET__CXhGYvq7__"